import { render, staticRenderFns } from "./side-image.vue?vue&type=template&id=34f7ef09&scoped=true"
import script from "./side-image.vue?vue&type=script&lang=js"
export * from "./side-image.vue?vue&type=script&lang=js"
import style0 from "./side-image.vue?vue&type=style&index=0&id=34f7ef09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7ef09",
  null
  
)

export default component.exports